import React from 'react';

interface PageHeaderProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  /** Slot bên phải: nút hành động, filter nhanh, badge... */
  extra?: React.ReactNode;
  className?: string;
}

// Header trang chuẩn SaaS (Material-3 teal / Stitch): icon chip tròn + tiêu đề
// Hanken Grotesk + subtitle, slot `extra` bên phải. Thay cho pattern cũ dùng
// Tabs type="card" một tab giả làm tiêu đề trang.
const PageHeader: React.FC<PageHeaderProps> = ({ icon, title, subtitle, extra, className }) => (
  <div className={`tw-mb-5 tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-3 ${className ?? ''}`}>
    {icon && (
      <div className="tw-flex tw-h-12 tw-w-12 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-surface-container-high tw-text-[24px] tw-text-primary">
        {icon}
      </div>
    )}
    <div className="tw-flex tw-flex-col">
      <h1 className="tw-m-0 tw-font-heading tw-text-xl tw-font-bold tw-leading-tight tw-text-on-surface">{title}</h1>
      {subtitle && <span className="tw-text-[13px] tw-text-on-surface-variant">{subtitle}</span>}
    </div>
    {extra && <div className="tw-ml-auto tw-flex tw-flex-wrap tw-items-center tw-gap-3">{extra}</div>}
  </div>
);

export default PageHeader;
